<template>
  <div :class="{'result-brightnessguide-not-ust': !isUSTWall || searchTabActive === 'Blending', 'extend-height': searchTabActive === 'Blending'}" class="result-brightnessguide">
    <div class="result-title" v-if="!isUSTWall || searchTabActive === 'Blending'">
      {{$t('T_BRIGHTNESS_CONTRAST_GUIDE')}}
      <span style="color: red;" v-show="searchTabActive === 'Blending'">({{$t('T_PER_ONE_UNIT')}})</span>
    </div>
    <div class="brightness_nit">
      <el-card class="box-card" shadow="never">
        <div class='birghtness' v-if="searchTabActive === 'Blending'">
          <div class="screen-position">
            <span>{{$t('T_BRIGHTNESS')}}</span>
          </div>
          <div class="screen-position_input_lux">
            <el-input class="roomsize_input" v-model='brightnessDataInput' @input="testDigital($event, 'brightnessDataInput')"></el-input>
            <span class='m'>{{$t('T_LUX')}}</span>
          </div>
        </div>
        <div class='ambient_screengain' v-if="searchTabActive === 'Blending'">
          <div class="screen-position">
            <span>{{$t('T_SCREENGAIN')}}</span>
          </div>
          <div class="screengain_input">
            <inputValidateBox prop='gainData' :rules="unitData === 'T_FEET_FRACTION' || unitData === 'T_INCH_FRACTION' ? rules.numberValid : rules.number">
              <el-input class="roomsize_input" v-model='gainData' @input="testDigital($event, 'gainData')" @blur='changGainMutation()' @keyup.enter.native='changGainMutation()'></el-input>
            </inputValidateBox>
          </div>
        </div>
        <div class="divider" v-if="searchTabActive === 'Blending'"></div>
        <div :class="{list: isUSTWall && searchTabActive !== 'Blending'}" >{{$t('T_BRIGHTNESS_ON_SCREEN_NIT')}} {{brightnessData | filterToFix1}}</div>
        <div :class="{list: isUSTWall && searchTabActive !== 'Blending'}" >{{$t('T_BRIGHTNESS_ON_SCREEN_LX')}} {{brightnessDataLx | filterToFix1}}</div>
        <div :class="{list: isUSTWall && searchTabActive !== 'Blending'}" >{{$t('T_CONTRAST_ON_SCREEN')}} {{contrastData | filterToFix2}}</div>
        <div :class = "{'img': !isUSTWall || searchTabActive === 'Blending', 'img-ust': isUSTWall && searchTabActive !== 'Blending'}" class=" clearfix" :style="{backgroundImage:'url(' + srcImage + ')', backgroundRepeat:'no-repeat', backgroundSize: 'contain'}">
          <div class="img_brightness">
            <div class="brightness-box" ref="brightnessBox">
              <div class="brightness-item" :style="{'background': item.color}" v-for="(item, index) in brightnessOptions" :key="index"></div>
            </div>
            <div class="img_brightness_line" :style="{'top': brightNessHeight}">
              <img src="../../assets/parts/result/brightness_line.png" alt="EPSON"/>
              <div class="img_brightness_line_text">{{ $t(shwoText) }}</div>
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import inputValidateBox from '@/components/inputValidateBox'
// import Brightness from '@/assets/data/brightness.json'

export default {
  name: 'resultBrightnessGuide',
  data () {
    return {
      brightNessHeight: '0%',
      positinIndex: 1,
      imgArray: {},
      srcImage: '',
      shwoTextArray: ['T_CRITERION_INDICATION_BEST', 'T_CRITERION_INDICATION_RECOMMEND', 'T_CRITERION_INDICATION_ENOUGH', 'T_CRITERION_INDICATION_LIMIT', 'T_CRITERION_INDICATION_TOO_LOW'],
      shwoText: '',
      gainData: '',
      rules: {
        'number': [
          {required: true, message: 'T_ALERT_DISPLAY_INPUT_NEED'}
        ],
        'numberValid': [
          {required: true, message: 'T_ALERT_DISPLAY_INPUT_NEED'},
          {pattern: /^\d+\.\d+$|\\+$|"+$/g, message: 'T_ALERT_DISPLAY_INPUT_ERROR'}
        ]
      }
    }
  },

  components: {
    inputValidateBox
  },

  mounted () {
    this.init()
  },

  methods: {
    init () {
      this.getBrightNessHeight()
      this.gainData = this.gainComputed
      this.initSrcImage()
    },

    getBrightNessHeight (value) {
      value = value || this.contrastData
      let brightNessHeight = 0
      for (let i = 0; i < this.brightnessOptions.length; i++) {
        this.positinIndex = i + 1
        if (value >= this.brightnessOptions[0].max) {
          brightNessHeight = 0
          this.shwoText = ''
          break
        } else {
          if (value >= this.brightnessOptions[i].min && value < this.brightnessOptions[i].max) {
            brightNessHeight = (this.brightnessOptions[i].max - value) / (this.brightnessOptions[i].max - this.brightnessOptions[i].min) * 0.2 + i * 0.2
            this.shwoText = this.shwoTextArray[i]
            break
          }
        }
      }

      this.brightNessHeight = this.$refs.brightnessBox.offsetHeight * brightNessHeight + 10 + 'px'
      if (isNaN(value)) {
        this.positinIndex = 1
      }
    },

    getConstratData (whiteNormal, aspectRatio, screenSize, brightness) {
      let whiteNormalNum = whiteNormal.split('ml')[0]
      let [aspectRatioX, aspectRatioY] = aspectRatio.split(':')
      return whiteNormalNum *
        (Math.pow(aspectRatioX, 2) + Math.pow(aspectRatioY, 2)) /
        (Math.pow(screenSize, 2) * aspectRatioX * aspectRatioY * Math.pow(0.0254, 2) * brightness) +
        1
    },

    getImgSrc (srcName) {
      if (!this.imgArray[srcName]) {
        this.imgArray[srcName] = require('@/assets/parts/result/' + srcName + '.jpg')
      }
      this.imgArray[srcName] = this.imgArray[srcName] || require('@/assets/parts/result/' + srcName + '.jpg')
      this.srcImage = this.imgArray[srcName]
    },

    initSrcImage () {
      let imgNameArray = [
        'meeting',
        'classroom',
        'hall',
        'living',
        'theatre',
        'hall'
      ]
      let tempName = imgNameArray[this.application] + '_' + this.positinIndex
      if (this.searchTabActive === 'Blending' && this.blendingParam && this.blendingParam.shapeShow !== '2') {
        tempName = 'hall_' + this.positinIndex
      }
      this.getImgSrc(tempName)
    },

    testDigital (e, key) {
      e = e.replace(/[^0-9|.]/ig, '')
      let n = (this[key].split('.') || []).length - 1
      if (n > 1) {
        e = ''
      }
      this[key] = e
    },

    changGainMutation () {
      if (isNaN(this.gainData) || this.gainData === '') this.gainData = '0'
      this.gainData = (this.gainData * 1).toFixed(1)
      this['SET_GAIN'](this.gainData)
    },

    ...mapMutations(['SET_GAIN', 'SET_BRIGHTNESS'])
  },

  filters: {
    filterToFix1 (value) {
      return (value * 1).toFixed(1)
    },

    filterToFix2 (value) {
      if (isNaN(value)) {
        return value
      }
      return value.toString().match(/^-?\d+(\.\d{1})?/)[0] + ':1'
    }
  },

  computed: {
    ...mapState([
      'selectedModelData',
      'gain',
      'graph',
      'selectedLensData',
      'screenSize',
      'brightness',
      'application',
      'isUSTWall',
      'aspectRatio',
      'searchTabActive',
      'blendingParam',
      'simulateTabSele',
      'simulateTabData',
      'fromBlending'
    ]),

    showData () {
      return this.simulateTabData.length > 0 ? this.simulateTabData[this.simulateTabSele] : {}
    },

    brightnessData () {
      let b = this.$commonJs.brightnessCoefficient()
      // console.log('b', b, 'this.gain', this.gain, 'this.graph.scrnW', this.graph.scrnW, 'this.graph.scrnH', this.graph.scrnH)
      let screenW = this.fromBlending && this.showData.screenW ? this.showData.screenW : this.graph.scrnW
      let screenH = this.fromBlending && this.showData.screenH ? this.showData.screenH : this.graph.scrnH
      return b * this.gain / (screenW * screenH * Math.PI / 10000)
    },

    brightnessDataLx () {
      let b = this.$commonJs.brightnessCoefficient()
      let screenW = this.fromBlending && this.showData.screenW ? this.showData.screenW : this.graph.scrnW
      let screenH = this.fromBlending && this.showData.screenH ? this.showData.screenH : this.graph.scrnH
      return b / (screenW * screenH / 10000)
    },

    contrastData () {
      let b = this.$commonJs.brightnessCoefficient() + ''
      let sreenSize = this.fromBlending && this.showData.size ? this.showData.size : this.screenSize
      let result = this.getConstratData(b, this.aspectRatio, sreenSize, this.brightness)
      return result > 200 ? this.$t('T_MAX_CONSTRAST') : result
    },
    brightnessOptions () {
      const APPLICATIONOPTIONS = {
        '0': [{
          max: 200,
          min: 20
        }, {
          max: 20,
          min: 15
        }, {
          max: 15,
          min: 8
        }, {
          max: 8,
          min: 3
        }, {
          max: 3,
          min: 0
        }],
        '1': [{
          max: 200,
          min: 15
        }, {
          max: 15,
          min: 10
        }, {
          max: 10,
          min: 7
        }, {
          max: 7,
          min: 5
        }, {
          max: 5,
          min: 0
        }],
        '2': [{
          max: 200,
          min: 15
        }, {
          max: 15,
          min: 7
        }, {
          max: 7,
          min: 5
        }, {
          max: 5,
          min: 3
        }, {
          max: 3,
          min: 0
        }],
        '3': [{
          max: 200,
          min: 10
        }, {
          max: 10,
          min: 5
        }, {
          max: 5,
          min: 4
        }, {
          max: 4,
          min: 3
        }, {
          max: 3,
          min: 0
        }],
        '4': [{
          max: 200,
          min: 80
        }, {
          max: 80,
          min: 50
        }, {
          max: 50,
          min: 30
        }, {
          max: 30,
          min: 20
        }, {
          max: 20,
          min: 0
        }],
        '5': [{
          max: 200,
          min: 15
        }, {
          max: 15,
          min: 7
        }, {
          max: 7,
          min: 5
        }, {
          max: 5,
          min: 3
        }, {
          max: 3,
          min: 0
        }]
      }
      const COLOROPTIONS = ['#dae3f3', '#b4c7e7', '#8faadc', '#2f5597', '#203864', '#8faadc']
      let temp = APPLICATIONOPTIONS[this.application] || []
      temp.forEach((item, i) => {
        item.color = COLOROPTIONS[i]
      })
      return temp
    },

    brightnessDataInput: {
      get () {
        return this.brightness
      },

      set (value) {
        if (isNaN(value)) value = '0'
        if (value.length > 1 && value[0] === '0' && value[1] !== '.') {
          value = value.substr(1)
        }
        this.SET_BRIGHTNESS(value)
      }
    },

    unitData () {
      return this.graph.unit
    },

    gainComputed () {
      return this.gain
    }
  },

  watch: {
    contrastData (newValue, oldValue) {
      this.getBrightNessHeight(newValue)
    },

    application (newValue, oldValue) {
      let imgNameArray = [
        'meeting',
        'classroom',
        'hall',
        'living',
        'theatre',
        'hall'
      ]
      let tempName = imgNameArray[newValue] + '_' + this.positinIndex
      if (this.searchTabActive === 'Blending' && this.blendingParam && this.blendingParam.shapeShow !== '2') {
        tempName = 'hall_' + this.positinIndex
      }
      this.getImgSrc(tempName)
    },

    positinIndex (newValue, oldValue) {
      let imgNameArray = [
        'meeting',
        'classroom',
        'hall',
        'living',
        'theatre',
        'hall'
      ]
      let tempName = imgNameArray[this.application] + '_' + newValue
      if (this.searchTabActive === 'Blending' && this.blendingParam && this.blendingParam.shapeShow !== '2') {
        tempName = 'hall_' + newValue
      }
      this.getImgSrc(tempName)
    },

    gainComputed (newValue, oldValue) {
      this.gainData = newValue
    }
  }
}
</script>

<style scoped>
.result-brightnessguide {
  margin-top: 10px;
  background: #fff;
}
.result-brightnessguide-not-ust {
  width: 470px;
  height: 361px;
  border: 2px solid #bdbdbd;
  border-right: none;
}
.img {
  position: absolute;
  margin-top: 10px;
  margin-left: 8px;
  height: 240px;
  width: 430px;
  left: 10px;
  bottom: 15px;
}
.img-ust {
  margin-top: 10px;
  margin-left: 8px;
  height: 175px;
  width: 315px;
  left: 10px;
  bottom: 15px;
}
.img_brightness {
  float: left;
  position: relative;
  font-size: 0;
  top: 50%;
  transform: translateY(-50%);
  line-height: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.65)
}

.img_contrast {
  margin-left: 8px;
}
.img_brightness_line {
  position: absolute;
  top: 0;
  left: 10px;
  transform: translateY(-100%);
  z-index: 111;
  width: 400px;
}

.img_brightness_line img {
  vertical-align:bottom;
}

.brightness-item {
  height: 20%;
  width: 100%;
}

.brightness-box {
  height: 90%;
  width: 40px;
  margin: 10px;
}
.box-card .list{
  margin-bottom:10px
}

.img_brightness_line_text {
  color: #fff;
  background: #10218b;
  height: 14px;
  line-height: 14px;
  font-size: 10px;
  width: auto;
  display: inline-block;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  padding-right: 5px;
  vertical-align:bottom;
}

.extend-height {
  height: 440px;
}

.birghtness {
  line-height: 26px;
  padding: 5px 0px 5px 0px;
}

  .screen-position {
  float: left;
  width: 233px;
}

.divider {
  border: 1px dashed #ccc;
  margin: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/view/result/resultBrightnessGuide.vue